import { Component, ElementRef, HostListener, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { QuestionnaireService } from '../services/questionnaire.service';
import { LeadService } from "../services/lead.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { mizrahiTefhotBranches } from '../mizrahi tefaho branchs';
import { SystemTablesService } from "../services/system-tables.service";
import { Draft } from '../services/draft.service';
import { TermsOfUseFinalComponent } from '../terms-of-use-final/terms-of-use-final.component';
import { TranslateService } from '@ngx-translate/core';
import { FormControl } from '@angular/forms';
import { timeout } from 'rxjs/operator/timeout';
import { environment } from '../../environments/environment';
import { AnalyticsService } from '../services/analytics.service'

@Component({
	selector: 'app-summarize-page',
	templateUrl: './summarize-page.component.html',
	styleUrls: ['./summarize-page.component.scss'],
	encapsulation: ViewEncapsulation.Emulated
})
export class SummarizePageComponent implements OnInit {
	user;
	errorMessage = [];
	userDetailsStep = this.questionnaireService.getStep("user-details");
	propertyDetailsStep = this.questionnaireService.getStep("property-details");
	loanDetailsStep = this.questionnaireService.getStep("loan-details");
	financingSourcesStep = this.questionnaireService.getStep("financing-sources");
	propertyValueOtherOptions = this.questionnaireService.getQuestion(this.propertyDetailsStep, "2").answer.fields[0].answerValue;
	propertyValueSelfContruction = this.questionnaireService.getQuestion(this.propertyDetailsStep, "3").answer.fields[0].answerValue +
		this.questionnaireService.getQuestion(this.propertyDetailsStep, "3").answer.fields[1].answerValue;
	ifMehirLeMishtakerProject = this.questionnaireService.getQuestion(this.loanDetailsStep, "6").selectedAnswer[0] === "YES";
	propertyValueMishtakenValue = this.questionnaireService.getQuestion(this.loanDetailsStep, "7").answer.fields[1].answerValue;
	advisors = this.questionnaireService.getStep("advisors");
	currentStep;
	summarizePage: FormGroup;
	submitted = false;
	isAdvisor = this.questionnaireService.getIsAdvisor();
	isActive: boolean = true;
	branchList;
	modalRef;
	defaultValue = "";
	isloading: boolean = false;
	errorMessageOnComponent = [];
	errorMessageOnComponent2 = [];
	errorMessageOnComponent3 = [];
	isDisplayed = false;
	isDisplayed2 = false;
	isDisplayed3 = false;
	@ViewChild('summarizeTextArea') summarizeTextArea: ElementRef;
	agreeEmail: FormControl = new FormControl(false);
	agreeApp: FormControl = new FormControl(false);
	whatsAppLink: string = environment.common.whatsAppLink;
	constructor(
		private router: Router,
		private fb: FormBuilder,
		private questionnaireService: QuestionnaireService,
		private leadService: LeadService,
		private modalService: NgbModal,
		private systemTablesService: SystemTablesService,
		private translate: TranslateService,
		private analyticsService: AnalyticsService,
		private formBuilder: FormBuilder,
		private draftService: Draft

	) {
		//this.branchList = mizrahiTefhotBranches;
	}

	ngOnInit() {
		this.errorMessage = [];
		this.branchList = this.systemTablesService.getTable('1225');
		window.scrollTo(0, 0);
		this.createForm();
		this.setValidators();
		// this.getSystemTbl();
		this.user = {
			firstName: (this.isAdvisor) ?
				this.questionnaireService.getQuestion(this.advisors, "1").answer.fields[0].answerValue || "חסר"
				: this.questionnaireService.getQuestion(this.userDetailsStep, "1").answer.fields[0].answerValue || "חסר",
			nameClient: this.questionnaireService.getQuestion(this.userDetailsStep, "1").answer.fields[0].answerValue || "חסר",
			propertyValue: this.questionnaireService.getQuestion(this.loanDetailsStep, "1").selectedAnswer[0] === '5' ?
				this.propertyValueSelfContruction : (this.ifMehirLeMishtakerProject ? this.propertyValueMishtakenValue : this.propertyValueOtherOptions),
			mortgageAmount: this.questionnaireService.getQuestion(this.loanDetailsStep, "2").answer.fields[0].answerValue || "",
			monthlyRefundAmount: this.questionnaireService.getQuestion(this.financingSourcesStep, "5").answer.fields[0].answerValue,
		};

		this.summarizeTextArea.nativeElement.focus();
		this.summarizePage.controls['emailOrApp'].setValue('01');

	}

	onSubmit({ value, valid }: { value: any, valid: boolean }) {
		this.errorMessage = [];
		this.submitted = true;
		//this.agree.value

		if (this.summarizePage.controls['textArea']
			&& this.summarizePage.controls['textArea'].hasOwnProperty('errors')
			&& this.summarizePage.controls['textArea'].errors != null) {
			if (this.summarizePage.controls['textArea'].errors.hasOwnProperty('pattern')
				&& this.summarizePage.controls['textArea'].errors.pattern) {
				this.errorMessage = [{ text: this.translate.instant('COMMON.GENERAL_PATTERN_ERROR') }];
			}
			if (this.summarizePage.controls['textArea'].errors.hasOwnProperty('maxlength')
				&& this.summarizePage.controls['textArea'].errors.maxlength) {
				this.errorMessage = [{ text: this.translate.instant('COMMON.TEXT_AREA_MAXLENGTH_ERROR') }];
			}
		}

		if (this.questionnaireService.openTermsOfUse === false) {
			if (!this.summarizePage.controls['continueBranch'].value || (this.isAdvisor && !(this.summarizePage.controls['remoteFlow'].value === 'YES' || this.summarizePage.controls['remoteFlow'].value === 'NO'))) {
				this.errorMessageOnComponent3 = [{ text: this.translate.instant('SUMMARIZE.ERROR_CHECKBOX') }];
				this.isDisplayed3 = true;
			}
			else {
				this.isDisplayed3 = false;
			}
			if (this.summarizePage.controls['emailOrApp'].value === "") {
				this.errorMessageOnComponent2 = [{ text: this.translate.instant('SUMMARIZE.ERROR_CHECKBOX') }];
				this.isDisplayed2 = true;
			}
			else {
				if ((!this.isAdvisor && valid) || (this.isAdvisor && (this.summarizePage.controls['remoteFlow'].value === 'YES' || this.summarizePage.controls['remoteFlow'].value === 'NO'))) {
					this.isDisplayed2 = false;
					let currentQuestion = this.questionnaireService.getQuestion(this.currentStep, "1");
					let textValue = this.summarizePage.controls['textArea'].value;
					let textArea = textValue !== '' ? textValue.replace(/\n/ig, ' ') : 'אין';
					this.questionnaireService.saveData(currentQuestion, [textArea]);
					currentQuestion.hasAnswer = true;

					let currentQuestion2 = this.questionnaireService.getQuestion(this.currentStep, "2");
					this.questionnaireService.saveData(currentQuestion2, [this.questionnaireService.getQuestion(this.currentStep, "2").selectedAnswer]);
					currentQuestion2.hasAnswer = true;	  

					let currentQuestion3 = this.questionnaireService.getQuestion(this.currentStep, "3");
					this.questionnaireService.saveData(currentQuestion3, [this.summarizePage.controls['continueBranch'].value]);
					currentQuestion3.hasAnswer = true;
					//this.draftService.buildArrDraft(this.submitQID, this.qFields, valueTmp, this.currentStep, this.isEdit)
					let arrTmp: any[];
					if (this.questionnaireService.getIsAdvisor() && !this.summarizePage.controls['continueBranch'].value && !(this.summarizePage.controls['remoteFlow'].value === 'YES')) {
						this.errorMessageOnComponent = [{ text: this.translate.instant('SUMMARIZE.ERROR') }];
						this.isDisplayed = true;
					}
					else {
						this.isDisplayed = false;
						this.errorMessageOnComponent = [];
						if (this.summarizePage.controls['continueBranch'].value || this.summarizePage.controls['remoteFlow'].value === 'YES'){
							let continueBranch = "";
							if(this.summarizePage.controls['remoteFlow'].value === 'YES'){
								continueBranch = "839";
							}
							else{
								continueBranch = this.branchList.find(v => v.name === this.summarizePage.controls['continueBranch'].value).code;
							}
							arrTmp = this.draftService.saveArrDataBasetmp.slice(this.draftService.saveArrDataBasetmp.length - 2, this.draftService.saveArrDataBasetmp.length - 1)
							if (arrTmp[0]["stepName"] === "summarize-page" && arrTmp[0]["qID"] === "1") {
								this.draftService.saveArrDataBasetmp = this.draftService.saveArrDataBasetmp.slice(0, this.draftService.saveArrDataBasetmp.length - 2)
							}
							this.draftService.saveArrDataBasetmp.push(
								{
									"stepName": "summarize-page",
									"qID": "1",
									"qNames": ["continueBranch"],
									"type": "String",
									"systemTable": "",
									"qNamesSystemTable": "",
									"numberSystemTable": "",
									"answers": [continueBranch]
								})
						}
						arrTmp = this.draftService.saveArrDataBasetmp.slice(this.draftService.saveArrDataBasetmp.length - 1, this.draftService.saveArrDataBasetmp.length)
						if (arrTmp[0]["stepName"] === "summarize-page" && arrTmp[0]["qID"] === "2") {
							this.draftService.saveArrDataBasetmp = this.draftService.saveArrDataBasetmp.slice(0, this.draftService.saveArrDataBasetmp.length - 1)
						}
						this.draftService.saveArrDataBasetmp.push(
							{
								"stepName": "summarize-page",
								"qID": "2",
								"qNames": ["summarize"],
								"type": "String",
								"systemTable": "",
								"qNamesSystemTable": "",
								"numberSystemTable": "",
								"answers": [textArea]
							})
						// arrTmp = this.draftService.saveArrDataBasetmp.slice(this.draftService.saveArrDataBasetmp.length - 1, this.draftService.saveArrDataBasetmp.length)
						// if(arrTmp[0]["stepName"]==="summarize-page" && arrTmp[0]["qID"]==="3"){
						// 	this.draftService.saveArrDataBasetmp = this.draftService.saveArrDataBasetmp.slice(0, this.draftService.saveArrDataBasetmp.length - 1)
						// }
						// this.draftService.saveArrDataBasetmp.push(
						// 	{
						// 	"stepName": "summarize-page",
						// 	"qID": "3",
						// 	"qNames": ["agreeEmail"],
						// 	"type": "String",
						// 	"systemTable": "",
						// 	"qNamesSystemTable": "",
						// 	"numberSystemTable": "",
						// 	"answers": [this.agreeEmail.value]
						// 	})
						// arrTmp = this.draftService.saveArrDataBasetmp.slice(this.draftService.saveArrDataBasetmp.length - 1, this.draftService.saveArrDataBasetmp.length)
						// if(arrTmp[0]["stepName"]==="summarize-page" && arrTmp[0]["qID"]==="4"){
						// 	this.draftService.saveArrDataBasetmp = this.draftService.saveArrDataBasetmp.slice(0, this.draftService.saveArrDataBasetmp.length - 1)
						// }
						// this.draftService.saveArrDataBasetmp.push(
						// 	{
						// 	"stepName": "summarize-page",
						// 	"qID": "4",
						// 	"qNames": ["agreeApp"],
						// 	"type": "String",
						// 	"systemTable": "",
						// 	"qNamesSystemTable": "",
						// 	"numberSystemTable": "",
						// 	"answers": [this.agreeApp.value]
						// 	})
						console.log(this.draftService)
						this.modalRef = this.modalService.open(TermsOfUseFinalComponent, { size: 'lg' });
						this.modalRef.result.then((result) => {
							if (result.isAgree) {
								this.summarizePage.controls['textArea'].disable();
								this.summarizePage.controls['continueBranch'].disable();
								// if (this.summarizePage.controls['emailOrApp'].value == "03") {
								// 	this.draftService.emailOrApp = "02";
								// }
								// else {
								this.draftService.emailOrApp = this.summarizePage.controls['emailOrApp'].value;
								// }
								setTimeout(() => {
									this.isloading = false;
									if (this.errorMessage.length === 0) {
										this.errorMessage = [{
											text: this.translate.instant('SUMMARIZE.ERROR-MSG1')
												.replace('WhatsApp', '<a href="' + this.whatsAppLink + '" target=_blank>WhatsApp</a>')
										}];
									}
								}, 20000)
								this.isloading = true;
								this.draftService.sendTMFinal$().subscribe(
									data => {
										this.questionnaireService.setAsmachta(data['oppNumber']);
										console.log("send TM succeed");
										this.errorMessage = [];
										this.router.navigate(['end']);
										this.isloading = false;
										this.summarizePage.controls['textArea'].enable();
										this.summarizePage.controls['continueBranch'].enable();
									},
									error => {
										if ((error.type && error.type === 2) && (error.code && error.code.message === '2')) {
											this.analyticsService.trackEvent("טופס בקשת משכנתא ארוך", "שלב 7 - סיכום", "לא ניתן להגיש טופס יותר מפעם אחת");
											this.errorMessage = [{
												text: this.translate.instant('SUMMARIZE.ERROR-MSG2')
													.replace('WhatsApp', '<a href="' + this.whatsAppLink + '" target=_blank>WhatsApp</a>')
											}];
										}
										else {
											this.analyticsService.trackEvent("טופס בקשת משכנתא ארוך", "שלב 7 - סיכום", "general_error");
											this.errorMessage = [{
												text: this.translate.instant('SUMMARIZE.ERROR-MSG1')
													.replace('WhatsApp', '<a href="' + this.whatsAppLink + '" target=_blank>WhatsApp</a>')
											}];
										}
										console.log("send TM failed");
										this.isloading = false;
										this.summarizePage.controls['textArea'].enable();
										this.summarizePage.controls['continueBranch'].enable();

										// this.questionnaireService.setAsmachta('');
										// console.log("send TM succeed");
										// this.errorMessage = "";
										// this.router.navigate(['end']);
										// this.isloading = false;
										// this.summarizePage.controls['textArea'].enable();
										// this.summarizePage.controls['continueBranch'].enable();
									}
								)
							}
						});
						this.modalRef.componentInstance.submitForm = true;
					}
				}
			}
		}
	}

	createForm() {
		this.currentStep = this.questionnaireService.getStep("summarize");
		this.questionnaireService.getQuestion(this.currentStep, "2").selectedAnswer = 'YES';
		this.summarizePage = this.fb.group({
			textArea: this.questionnaireService.getQuestion(this.currentStep, "1").answer.fields[0].answerValue,
			marketingCB: this.questionnaireService.getQuestion(this.currentStep, "2"),
			continueBranch: this.questionnaireService.getQuestion(this.currentStep, "3").answer.fields[0].answerValue,
			emailOrApp: this.questionnaireService.getQuestion(this.currentStep, "4").selectedAnswer,
			remoteFlow: "",
		});	
	}

	setValidators() {
		this.summarizePage.controls['textArea'].setValidators([Validators.pattern("^[0-9A-Za-zא-ת\ \n]*$"), Validators.maxLength(256)]);
		this.submitted = false;
	}

	@HostListener('window:keydown', ['$event'])
	keyEvent(event: KeyboardEvent): any {
		if (event.key === 'Enter') {
			if ((event.target as HTMLButtonElement).dataset.id === 'but-summary-submit' ||
				(event.target as HTMLButtonElement).dataset.id === 'summary-textarea') {
				this.onSubmit(this.summarizePage);
			}

		}

	}
}



// WEBPACK FOOTER //
// ./src/app/summarize-page/summarize-page.component.ts